const BORDER_COLOR = "#D3D3D3";

export function getId(value: unknown): string {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && value !== null && "id" in value) {
    return String((value as any).id ?? "");
  }
  return "";
}

export function tabSx(isActive: boolean) {
  return {
    textTransform: "none",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontWeight: isActive ? 700 : 500,
    fontSize: "0.95rem",
    minHeight: 0,
    py: 1.2,
    px: 2.5,
    mr: 0.4,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    border: isActive ? `1px solid ${BORDER_COLOR}` : "1px solid transparent",
    borderBottom: isActive ? "1px solid #FFFFFF" : "1px solid transparent",
    bgcolor: isActive ? "#FFFFFF" : "transparent",
    color: "#1D3D4D",
    "&:hover": {
      bgcolor: isActive ? "#FFFFFF" : "rgba(144,175,197,0.12)",
    },
  } as const;
}
